import { render } from "./yinsishengming.vue?vue&type=template&id=66627036&scoped=true"
import script from "./yinsishengming.vue?vue&type=script&lang=js"
export * from "./yinsishengming.vue?vue&type=script&lang=js"

import "./yinsishengming.vue?vue&type=style&index=0&id=66627036&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66627036"]])

export default __exports__